import { FC, useEffect } from 'react';
import { Divider, Stack, Typography } from '@mui/material';
import { useGetMessageQuery, useMarkNotificationAsReadMutation } from '../../graphql/generated/operations/messages.ts';
import { LoadingBackdrop } from '../../components/loading.backdrop.tsx';
import { useParams } from 'react-router-dom';
import { addMinutes, formatDistanceToNow } from 'date-fns';
import { trackEvent } from '../../utils/analytics.ts';

export const MessagePage: FC = () => {
  const { id } = useParams();
  const { loading, data } = useGetMessageQuery({
    variables: { id: id || '' },
    skip: !id
  });
  const [markedRead] = useMarkNotificationAsReadMutation();

  useEffect(() => {
    if (data?.notification && !data?.notification.readAt) {
      markedRead({ variables: { id: data.notification._id } });
    }
    if (data?.notification) {
      trackEvent('message_view', { messageId: data.notification._id });
    }
  }, [data]);

  if (loading) {
    return <LoadingBackdrop />;
  }
  return (
    <Stack spacing={3}>
      <Typography variant="h4">{data?.notification.message?.title}</Typography>
      <Typography>
        {data?.notification.scheduledAt ? formatDistanceToNow(addMinutes(new Date(data?.notification.scheduledAt), new Date().getTimezoneOffset())) + ' ago' : null}
      </Typography>
      <Divider />
      <Typography>{data?.notification.message?.body}</Typography>
    </Stack>
  );
};
